import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "./styles/library.css";
import App from "./components/shared/App";
import { store } from "./store";

const root = ReactDOM.createRoot(document.querySelector("#root") as Element);

root.render(
  <Provider store={store}>
    <App />
  </Provider>
);
